module.exports = __webpack_public_path__ + "img/skull_10_bj.08937257.png";